/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

function filterSearchGrid(grid: HTMLElement, searchResult: any, clear: boolean = false) {
  const idArray = [];
  searchResult.forEach((result) => {
    idArray.push(result.ref);
  });

  grid.querySelectorAll('.postTypeGrid__item').forEach((item: HTMLElement) => {
    if (!clear) {
      if (idArray.includes(item.dataset.itemId)) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    } else {
      item.style.display = '';
    }
  });
}

const lunrEnabled: NodeListOf<HTMLElement> | null = document.querySelectorAll('.lunrSearchEnabled');
if (lunrEnabled && lunrEnabled.length !== 0) {
  import(/* webpackChunkName: "elasticlunr" */ 'elasticlunr').then((module) => {
    // Initialize lunr search
    const elasticlunr = module.default;

    // Get all search containers
    Array.from(lunrEnabled).forEach((wrapper) => {
      // Get search field
      const inputField: HTMLInputElement = wrapper.querySelector('.lunrSearchField');

      // Get search data json
      const lunrData = JSON.parse(wrapper.dataset.lunrSearch!);

      // Remove data from DOM
      wrapper.removeAttribute('data-lunr-search');

      // Setup the search index
      const searchIndex = elasticlunr(function () {
        this.addField('title');
        this.addField('body');
        this.addField('tags');
        this.setRef('id');
      });

      // Put data in search index
      lunrData.forEach((dataItem) => {
        searchIndex.addDoc(dataItem);
      });

      // Add event listener to search field
      inputField.addEventListener('input', () => {
        // Get field value
        const term = inputField.value;

        // If field is empty, show all
        if (!term || term === '') {
          filterSearchGrid(wrapper, [], true);
          return;
        }

        // Start the search
        const results = searchIndex.search(term, {
          expand: true,
        });

        // Filter the results
        if (results.length) {
          filterSearchGrid(wrapper, results);
        }
      });
    });
  });
}
